// Store territorial partagé (frontend uniquement).
//
// Le découpage territorial du Burkina Faso vit désormais dans un store unique,
// initialisé depuis la source centrale `@/config/territory`. Les quatre niveaux
// sont stockés à plat (chaque nœud référence son parent par identifiant), ce qui
// facilite les modifications, les suppressions protégées et, plus tard, une
// bascule directe vers des tables Supabase.

export type TerritoryLevel = "region" | "province" | "commune" | "secteur";

export interface TerritoryRegion {
  id: string;
  nom: string;
}

export interface TerritoryProvince {
  id: string;
  nom: string;
  regionId: string;
}

export interface TerritoryCommune {
  id: string;
  nom: string;
  provinceId: string;
}

export interface TerritorySecteur {
  id: string;
  nom: string;
  communeId: string;
}

export const TERRITORY_LEVEL_LABELS: Record<TerritoryLevel, string> = {
  region: "Région",
  province: "Province",
  commune: "Commune / Ville",
  secteur: "Secteur / Quartier",
};

export const TERRITORY_LEVEL_PLURALS: Record<TerritoryLevel, string> = {
  region: "Régions",
  province: "Provinces",
  commune: "Communes / Villes",
  secteur: "Secteurs / Quartiers",
};